import { createContext, ReactElement, ReactNode, useContext } from "react";
import { ContextType, DataProvider } from "./DataProvider";
import { DictItem } from "../shared/types/DictItem";

interface Props {
  children: ReactNode;
  cachePrefix?: string;
}

export const KeyValueDataContexMap = {
  proprarities: createContext<ContextType<DictItem> | null>(null),
  proptags: createContext<ContextType<DictItem> | null>(null),
  proptypes: createContext<ContextType<DictItem> | null>(null),
} as const;

export const KeyValueDataProvider = ({ children, cachePrefix }: Props) => {
  return Object.keys(KeyValueDataContexMap).reduceRight((acc, collection) => {
    return (
      <DataProvider
        key={collection}
        collection={collection}
        cacheKey={cachePrefix ? `${cachePrefix}:${collection}` : undefined}
        context={
          KeyValueDataContexMap[
            collection as keyof typeof KeyValueDataContexMap
          ]
        }
      >
        {acc}
      </DataProvider>
    );
  }, children) as ReactElement;
};

export const useKeyValueData = (
  collection: keyof typeof KeyValueDataContexMap,
) => {
  const context = useContext(KeyValueDataContexMap[collection]);
  if (!context)
    throw new Error(
      "useKeyValueData must be used within a KeyValueDataProvider",
    );
  return context;
};
